"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Range = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _styles = require("@material-ui/core/styles");

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _FormControl = _interopRequireDefault(require("../FormControl"));

var _FormGroup = _interopRequireDefault(require("../FormGroup"));

var _FormLabel = _interopRequireDefault(require("../FormLabel"));

var _styles2 = require("./styles");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var Range = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Range, _Component);

  var _super = _createSuper(Range);

  function Range() {
    var _this;

    (0, _classCallCheck2.default)(this, Range);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChange", function (key) {
      return function (event, value) {
        var onChange = _this.props.onChange;
        value = value ? value : event.target.value;
        onChange && onChange(event, _objectSpread(_objectSpread({}, _this.props.value), {}, (0, _defineProperty2.default)({}, key, value)));
      };
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fullWidth", function () {
      var _this$props = _this.props,
          fromProps = _this$props.fromProps,
          toProps = _this$props.toProps,
          fullWidth = _this$props.fullWidth;
      return fullWidth || fromProps && fromProps.fullWidth || toProps && toProps.fullWidth;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props2 = _this.props,
          autoFocus = _this$props2.autoFocus,
          Component = _this$props2.component,
          classes = _this$props2.classes,
          disabled = _this$props2.disabled,
          error = _this$props2.error,
          fromProps = _this$props2.fromProps,
          id = _this$props2.id,
          label = _this$props2.label,
          required = _this$props2.required,
          toProps = _this$props2.toProps,
          value = _this$props2.value,
          onBlur = _this$props2.onBlur,
          executeValidation = _this$props2.executeValidation,
          className = _this$props2.className;

      var _ref = value || {
        from: null,
        to: null
      },
          from = _ref.from,
          to = _ref.to;

      var fromId = id ? "".concat(id, "-range-from") : undefined;
      var rootLabelProps = {
        id: id,
        htmlFor: fromId,
        disabled: disabled
      };

      var fromComponentProps = _objectSpread(_objectSpread({}, fromProps), {}, {
        autoFocus: autoFocus,
        fullWidth: _this.fullWidth(),
        id: fromId,
        onChange: _this.onChange("from"),
        // This is meant to be invoked. It is a function returning a function.
        onBlur: onBlur,
        executeValidation: executeValidation,
        value: from,
        required: required,
        disabled: disabled
      });

      var toComponentProps = _objectSpread(_objectSpread({}, toProps), {}, {
        fullWidth: _this.fullWidth(),
        id: id ? "".concat(id, "-range-to") : undefined,
        onChange: _this.onChange("to"),
        // This is meant to be invoked. It is a function returning a function.
        onBlur: onBlur,
        executeValidation: executeValidation,
        required: required,
        value: to,
        disabled: disabled
      });

      return /*#__PURE__*/_react.default.createElement(_FormControl.default, {
        fullWidth: _this.fullWidth(),
        id: id,
        disabled: disabled,
        error: error,
        required: required
      }, label && /*#__PURE__*/_react.default.createElement(_FormLabel.default, (0, _extends2.default)({
        className: (0, _classnames.default)("prmbl-range-label", classes.rangeLabel),
        component: "label"
      }, rootLabelProps), label), /*#__PURE__*/_react.default.createElement(_FormGroup.default, {
        id: id ? id + "-range-group" : undefined,
        className: (0, _classnames.default)("prmbl-range", className, classes.root)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("prmbl-range-component", classes.component, (0, _defineProperty2.default)({}, classes.componentFullWidth, _this.fullWidth()))
      }, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, fromComponentProps, {
        margin: false
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)("prmbl-range-component", classes.component, (0, _defineProperty2.default)({}, classes.componentFullWidth, _this.fullWidth()))
      }, /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, toComponentProps, {
        margin: false
      })))));
    });
    return _this;
  }

  return Range;
}(_react.Component);

exports.Range = Range;
(0, _defineProperty2.default)(Range, "propTypes", {
  /**
   * If `true`  the input will be focused during the first mount.
   */
  autoFocus: _propTypes.default.bool,

  /**
   * If `true` the label, and input should be displayed in a disabled state.
   */
  disabled: _propTypes.default.bool,

  /**
   * 	If `true`, the input will indicate an error. And display the provided errorMessage
   */
  error: _propTypes.default.bool,

  /**
   * @ignore
   *
   * Utilized By:
   * CivicEngage, CP Platform
   */
  className: _propTypes.default.string,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * The component used for the input elements.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),

  /**
   * Container to store all the properties for the `from` component
   */
  fromProps: _propTypes.default.object,

  /**
   * The html id
   */
  id: _propTypes.default.string,

  /**
   * The contents of the `label`
   */
  label: _propTypes.default.node,

  /**
   * Callback fired when the value is changed.  `function(event: object, value: object) => void`
   *
   * `event` : The event source of the callback.
   *
   *
   * `value` : The value of the range. { from: ..., to: ... }
   */
  onChange: _propTypes.default.func.isRequired,

  /**
   * Callback to be called when the user switches focus from the input
   *
   * function(event: object) => void
   * `event` : The event source of the callback.
   */
  onBlur: _propTypes.default.func,

  /**
   * Function passed in from /Validation/index.js.. Used to bypass the checks inside index.js and call validation directly.
   */
  executeValidation: _propTypes.default.func,

  /**
   * Sets the label component to visually represent a required field.
   */
  required: _propTypes.default.bool,

  /**
   * Container to store all the properties for the `to` component
   */
  toProps: _propTypes.default.object,

  /**
   * The value of the range object
   */
  value: _propTypes.default.shape({
    /**
     * Value of the `From` input
     */
    from: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.object]),

    /**
     * Value of the `To` input
     */
    to: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number, _propTypes.default.object])
  }),

  /**
   * Makes the Range width 100%
   */
  fullWidth: _propTypes.default.bool
});
(0, _defineProperty2.default)(Range, "defaultProps", {
  className: "",
  id: ""
});

var _default = (0, _styles.withStyles)(_styles2.styles)(Range);

exports.default = _default;